import React, { useEffect, useState } from 'react';
import { styles } from "./styles";
import { Grid, Button, Typography, TextField } from "@mui/material";
import DataMuiSelect from 'components/MuiSelect/DataMuiSelect';
import { styles as inputStyles } from "common/inputStyles";
import DeviceStatusTableHeader from 'components/TableHeader/DeviceStatusTableHeader';
import StatusReportDataTable from 'components/DataTable/StatusReportDataTable';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import {getAllServiceProviders, getSegment, getAllDeviceTypes, getdevicesbyStatus } from 'apis/device';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CommonUtil from 'common/CommonUtil';
import ErrorPopup from 'common/ErrorPopup';
import dayjs, { Dayjs } from 'dayjs';

LicenseManager.setLicenseKey("CompanyName=Rehrig Pacific Company (Richardson, TX),LicensedApplication=Rehrig Vision,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-037353,SupportServicesEnd=29_December_2024_[v2]_MTczNTQzMDQwMDAwMA==2cc2796737bee66cd2e64e46b6c5759c")

interface DeviceStatusReportProps {
}

var pgNumber = 0;
var records: any = [];
const DeviceStatusReport: React.FC<DeviceStatusReportProps> = () => {
  const [searchVal, setSearchVal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [deviceData, setDeviceData] = useState<any>([]);
  const [err, setErr] = useState("");
  const [showCont, setShowCont] = useState(false);
  const [serviceProvider, setServiceProvider] = useState<any>(null);
  const [isServiceProviderError, setServiceProviderError] = useState(false);
  const [providers, setProviders] = useState([]);
  const [segments, setSegments] = useState([]);
  const [currSegment, setCurrSegment] = useState<any>(null);
  const [types, setTypes] = useState<any>([]);
  const [deviceTypeName, setDeviceTypeName] = useState<any>(null);
  const [deviceStatus, setDeviceStatus] = useState<any>({ key: CommonUtil.statuses[0].key, value: CommonUtil.statuses[0].value });
  const [deviceStatuses, setDeviceStatuses] = useState(CommonUtil.statuses);
  const [fromvalue, setFromvalue] = React.useState<Dayjs | null>(dayjs(new Date()));
  const [tovalue, settovalue] = React.useState<Dayjs | null>(dayjs(new Date()));
  const [isFromDateError, setFromDateError] = useState(false);
  const [isToDateError, setToDateError] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [checkedData, setCheckedData] = useState<any>(null);
  const [formattedData, setFormattedData] = useState<any>(null);
  const [deviceStatusRepoAfterFilter, setDeviceStatusRepoAfterFilter] = useState([]);

  const getAllDeviceStatus = async () => {
      let DType = deviceTypeName ? deviceTypeName.deviceTypeName : "";
      let DStatus = (deviceStatus) ? deviceStatus.value : "";
      let segId = currSegment ? currSegment.id : "";
      let spId = serviceProvider ? serviceProvider.id : "";
      const fDate = localStorage.getItem('fromDate');
      const tDate = localStorage.getItem('toDate');

      setDeviceData([]);
      records = [];
      pgNumber = 1;
      let data = await getdevicesbyStatus(DStatus, DType, segId, spId, fDate, tDate, pgNumber);
      if (data) {
        records = records.concat(data.devices);
        if(data.hasMoreRecords){
          while(true){
            pgNumber = pgNumber + 1;
            data = await getdevicesbyStatus(DStatus, DType, segId, spId, pgNumber);
            if(data){
                records = records.concat(data.devices);
            }
            if(records.length>=CommonUtil.DEVICE_STATUS_COUNT){
              setShowErrorPopup(true);
              break;
            }
            if(!data.hasMoreRecords){
              break;
            }
          }
        }
        records.forEach((object: any) => {
          if ('eventTimestampMillis' in object && object.eventTimestampMillis !== null) {
            const date = new Date(object.eventTimestampMillis);
            object.eventTimestampMillis = moment(date).local().format('MM/DD/YYYY h:mm:ss A');
          }
          if ('receivedTimestamp' in object && object.receivedTimestamp !== null) {
            object.receivedTimestamp = new Date(object.receivedTimestamp).toLocaleString();
          }
          if ('lastReportedEventTime' in object && object.lastReportedEventTime !== null) {
              const obj = object.lastReportedEventTime;
              if(obj.includes('+0000')){
                const date = new Date(object.lastReportedEventTime);
                object.lastReportedEventTime = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
              }
              else{
                object.lastReportedEventTime = new Date(object.lastReportedEventTime).toLocaleString();
              }
          }
          if ('receivedTime' in object && object.receivedTime !== null) {
            const obj = object.receivedTime;
            if(obj.includes('+0000')){
              const date = new Date(object.receivedTime);
              object.receivedTime = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
            }
            else{
              object.receivedTime = new Date(object.receivedTime).toLocaleString();
            }
        }
        if ('lastImageTime' in object && object.lastImageTime !== null) {
          const obj = object.lastImageTime;
          if(obj.includes('+0000')){
            const date = new Date(object.lastImageTime);
            object.lastImageTime = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
          }
          else{
            object.lastImageTime = new Date(object.lastImageTime).toLocaleString();
          }
      }
      if ('lastImageTime2' in object && object.lastImageTime2 !== null) {
        const obj = object.lastImageTime2;
        if(obj.includes('+0000')){
          const date = new Date(object.lastImageTime2);
          object.lastImageTime2 = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
        }
        else{
          object.lastImageTime2 = new Date(object.lastImageTime2).toLocaleString();
        }
    }
        });
        const sortedArray = records.sort((a: any, b: any) => {
          const dateA = new Date(a.eventTimestampMillis);
          const dateB = new Date(b.eventTimestampMillis);

          if (dateA > dateB) {
            return -1;
          } else if (dateA < dateB) {
            return 1;
          } else {
            return 0;
          }
        });
        let newArr = sortedArray.filter((s: any) => s.creationDate !== null);
        setDeviceData(sortedArray);
      }
      else {
        pgNumber = 0;
        setDeviceData([]);
      }
  }

  const getServiceProviders = async () => {
    let data = await getAllServiceProviders();
    if (data?.response?.data?.errorMessage) {
      return
    }
    if (data && data[0]) {
      setProviders(data);
    }
  }
  const getSegmentList = async (id: string) => {
    let data = await getSegment(id);
    if (data?.response?.data?.error) {
      console.log('error');
      return
    }
    if (data) {
      setSegments(data);
    }
  }
  const getDeviceTypes = async () => {
    let data = await getAllDeviceTypes();
    if (data?.response?.data?.errorMessage) {
      console.log('error');
      return
    }
    if (data) {
      setTypes(data);
    }
  }

  useEffect(() => {
    pgNumber = 0;
    records = [];
    getServiceProviders();
    getDeviceTypes();
  }, [])

  const onChangeServiceProvider = (data: any) => {
    setServiceProvider(data);
    setServiceProviderError(!data || data.length === 0);
    setSegments([]);
    setCurrSegment(null);
    if (data) {
      getSegmentList(data.id)
    }
  }

  const onChangeCurrSegmentHandler = (data: any) => {
    setCurrSegment(data);
  }

  const getDateValeus = () => {
    localStorage.removeItem('fromDate');
    localStorage.removeItem('toDate');
    let date: any = fromvalue?.get('date');
    let month: any = fromvalue?.get('month');
    let year: any = fromvalue?.get('year');

    let newMonth = month < 9 ? `0${month + 1}` : `${month + 1}`; //adding 0 to month if single digit
    let newdate = date < 10 ? `0${date}` : `${date}`; //adding 0 to date if single digit
    let fDate: any = `${newMonth}-${newdate}-${year}`;

    let tdate: any = tovalue?.get('date');
    let tmonth: any = tovalue?.get('month');
    let tyear: any = tovalue?.get('year');

    let tnewMonth = tmonth < 9 ? `0${tmonth + 1}` : `${tmonth + 1}`; //adding 0 to month if it is single digit
    let tnewdate = tdate < 10 ? `0${tdate}` : `${tdate}`; //adding 0 to date if it is single digit
    var tDate: any = `${tnewMonth}-${tnewdate}-${tyear}`;

    localStorage.setItem('fromDate', fDate);
    localStorage.setItem('toDate', tDate);
  }

  const getDeviceEvents = () => {
    if(isServiceProviderError || isFromDateError || isToDateError) {
      return false;
     }
     if(!serviceProvider || serviceProvider.length === 0) {
       setServiceProviderError(!serviceProvider || serviceProvider.length === 0);
       return false;
     }
     if(!fromvalue || !fromvalue.isValid()) {
       setFromDateError(!isFromDateError);
       return false;
     }
     if(!tovalue || !tovalue.isValid()) {
       setToDateError(!isToDateError);
       return false;
     }
     let hours = tovalue.diff(fromvalue, 'hours');
     const days = Math.floor(hours / 24);
     if(days > 6) {
       alert("Date range should not exceed 7 days.");
       return false;
     }
     if(days < 0) {
       alert("Invalid date range.")
       return false;
     }
    setDeviceData('');
    setFormattedData("");
    setCheckedData("");
    getDateValeus();
    getAllDeviceStatus();
  }

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  }

  const onChangeDeviceType = (data: any) => {
    console.log(data);
    if(data){
      setDeviceTypeName(data);
    }

  }
  const onChangeStatus = (data: any) => {
    setDeviceStatus(data);
  }

     // Downloading Only Filtered Data After Search
     const updateFilteredData = (data:[]) => {
      setDeviceStatusRepoAfterFilter(data);
    }

  return (
    <Grid container spacing={2}>
      {showImageModal}
      {showModal ? (err !== "" && <Typography sx={styles.errContainer}>{err}</Typography>) : ""}
      {showErrorPopup ? <ErrorPopup title='Data' popupText='10000 records loaded from available data' open={showErrorPopup} handlePopupClose={closeErrorPopup}></ErrorPopup> : ""}
      <Grid container spacing={2} style={{ width: '100%', marginTop: '5px', padding: '15px' }}>
        <Grid item xs={3} sx={{ marginBottom: "15px", marginTop: "0px" }}>
          <DataMuiSelect label={"Service Provider"} sKey={"id"} value={"name"} selectedValue={serviceProvider} dataSource={providers}
            onChangeHandler={(e: any) => onChangeServiceProvider(e)} mandatory={true} isError={isServiceProviderError} errorText={"Required Field."}/>
        </Grid>
        <Grid item xs={3} sx={{ marginBottom: "15px" }}>
          <DataMuiSelect label={"Segment"} sKey={"id"} value={"name"} selectedValue={currSegment} dataSource={segments}
            onChangeHandler={(e: any) => onChangeCurrSegmentHandler(e)} />
        </Grid>
        <Grid item xs={3} sx={{ marginBottom: "15px" }}>
          <DataMuiSelect label={"Device Type"} sKey={"deviceTypeName"} value={"deviceTypeName"} selectedValue={deviceTypeName} dataSource={types}
            onChangeHandler={(e: any) => onChangeDeviceType(e)} />
        </Grid>
        <Grid item xs={3} sx={{ marginBottom: "15px" }}>
          <DataMuiSelect label={"Status"} sKey={"key"} value={"value"} selectedValue={deviceStatus} dataSource={deviceStatuses}
            onChangeHandler={(e: any) => onChangeStatus(e)} />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ width: '100%', padding: '0px 15px' }}>
        <Grid item xs={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From"
              openTo="day"
              views={['year', 'month', 'day']}
              value={fromvalue}
              inputFormat="MM-DD-YYYY"
              onChange={(newValue) => {
                setFromvalue(newValue);
                setFromDateError(!newValue  || !newValue.isValid());
                setServiceProviderError(!serviceProvider || serviceProvider.length === 0);
              }}
              renderInput={(params) => <TextField  {...params} required={true} style={{ width: "100%" }} 
              error={isFromDateError || !fromvalue || !fromvalue.isValid()}
              helperText={isFromDateError ? ( !fromvalue ? "Requried Field.": "Invalid Date."):""}
              />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid xs={3} sx={{ marginTop: "15px", paddingLeft: '15px' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To"
              openTo="day"
              views={['year', 'month', 'day']}
              value={tovalue}
              inputFormat="MM-DD-YYYY"
              onChange={(newValue) => {
                settovalue(newValue);
                setToDateError(!newValue || !newValue.isValid());
                setServiceProviderError(!serviceProvider || serviceProvider.length === 0);
              }}
              renderInput={(params) => <TextField {...params} required={true} style={{ marginBottom: "15px", width: "100%" }} 
              error={isToDateError || !tovalue || !tovalue.isValid() }
              helperText={isToDateError ? ( !tovalue? "Requried Field.": "Invalid Date."):""}
              />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid xs={3} sx={{ paddingTop: "18px", paddingLeft: '15px' }}>
          <Button sx={inputStyles.buttonGreen} onClick={getDeviceEvents}>Search</Button>
        </Grid>
      </Grid>

      <DeviceStatusTableHeader searchVal={searchVal} setSearchVal={setSearchVal} setShowCont={setShowCont} setFormattedData={setFormattedData} formattedData={formattedData} checkedData={checkedData} setCheckedData={setCheckedData} data={deviceStatusRepoAfterFilter} csvLabel={"DeviceStatusReport.csv"} />
      <Grid item xs={12} sx={{ height: "80vh" }}>
        {/* Added Filtered data Download after Search (getFilteredData={updateFilteredData} ) */}
        <StatusReportDataTable data={deviceData} searchVal={searchVal} getFilteredData={updateFilteredData} />
      </Grid>
    </Grid>
  )
}

export default DeviceStatusReport;